import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Navigate, Outlet, Route, Router, Routes } from 'react-router-dom';
import LoginView from './views/commun/login_view';
import DashboardCliente from './views/client/dashboard_client';
import HomeClient from './views/client/home_client';
import HomePsico from './views/psicologo/home_psico';
import React, { Fragment } from 'react';
import CitaSinglePsico from './views/psicologo/cita_single_psico';
import AuthContextProvider from './context/auth_context';
import Renderif from './components/renderif';
import ClientNavigator from './navigator/client_navigator';
import PsicoNavigator from './navigator/psico_navigator';
import PoliticasPrivacidad from './views/commun/politicas_privacidad_view';
import PoliticasView from './views/commun/politicas_view';
import AlertNotification from './components/alert-notification';
import AlertContextProvider from './context/alert_context';
import RegisterView from './views/commun/register_view';
import RecuperarPassView from './views/commun/recuperar_pass_view';
import RresetPass from './views/commun/reset_pass_view';
import FamiliaClient from './views/client/familia_client';
import AdminNavigator from './navigator/admin_navigator';


function App() {

  return (

    <BrowserRouter>

      <AlertContextProvider>

        <AuthContextProvider>

          <AlertNotification></AlertNotification>

          <Routes>
            <Route path="/" element={<LoginView></LoginView>} />
            <Route path="/registro" element={<RegisterView></RegisterView>} />
            <Route path="/politicas" element={<PoliticasView></PoliticasView>} />
            <Route path="/recover-pass" element={<RecuperarPassView></RecuperarPassView>} />
            <Route path="/reset-password" element={<RresetPass></RresetPass>} />

            <Route exact path="/client/*" element={<ClientNavigator></ClientNavigator>} />
            <Route exact path="/admin/*" element={<PsicoNavigator></PsicoNavigator>} />
            <Route exact path="/administrador/*" element={<AdminNavigator></AdminNavigator>} />

            <Route path="/about" element={<div>about</div>} />

          </Routes>



        </AuthContextProvider>
      </AlertContextProvider>
    </BrowserRouter>

  )
};


function PrivateRoute({ children }) {
  // const { user } = useContext(AuthContext);
  const user = 0;
  return user ? children : <Navigate to="/" />;
}


export default App;
